export const DIRTY = (state, dirty) => {
  state.dirty = dirty;
};

export const IN_SYNC = (state, inSync) => {
  state.inSync = inSync;
};

export const ALERT = (state, payload) => {
  state.alert.type = payload.type ? payload.type : null;
  state.alert.title = payload.title ? payload.title : null;
  state.alert.message = payload.message ? payload.message : null;
};

export const SIGNIN = (state, payload) => {
  state.session.accessToken = payload.access_token;
  state.session.expiresAt = payload.expires_at;
};

export const SIGNOUT = state => {
  state.session.user = null;
  state.session.accessToken = null;
  state.session.expiresAt = null;
};

export const SET_USER = (state, payload) => {
  state.session.user = payload;
};

export const LOAD_SESSION = (state, payload) => {
  state.session = payload;
};

export const REDIRECT_SET = (state, payload) => {
  state.session.redirectUrl = payload.redirectUrl;
};
